import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';
import { buildCrumbs } from './breadcrumbConfig';
import { useBreadcrumbLeaf } from '../../context/BreadcrumbContext';

// App-wide breadcrumb trail. Derives the trail from the current path via
// breadcrumbConfig, and lets the active page override the leaf label with a
// real name (horse/sire) through BreadcrumbContext.
export default function Breadcrumbs() {
  const location = useLocation();
  const navigate = useNavigate();
  const leafLabel = useBreadcrumbLeaf();

  const crumbs = buildCrumbs(location.pathname);
  if (!crumbs || crumbs.length <= 1) return null; // nothing useful to show

  const lastIdx = crumbs.length - 1;

  return (
    <nav aria-label="Breadcrumb" className="min-w-0 flex-1">
      <ol className="flex items-center gap-1 text-xs text-text-muted overflow-hidden">
        {crumbs.map((crumb, i) => {
          const isLast = i === lastIdx;
          const label = isLast && crumb.dynamic && leafLabel ? leafLabel : crumb.label;
          return (
            <li key={i} className="flex items-center gap-1 min-w-0">
              {i > 0 && <FiChevronRight size={12} className="flex-shrink-0 opacity-50" />}
              {crumb.to && !isLast ? (
                <button
                  onClick={() => navigate(crumb.to)}
                  className="hover:text-text transition-colors truncate max-w-[16ch] sm:max-w-[24ch]"
                  title={label}
                >
                  {label}
                </button>
              ) : (
                <span
                  className={`truncate max-w-[16ch] sm:max-w-[28ch] ${isLast ? 'text-text font-medium' : ''}`}
                  title={label}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
